import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCocktail: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconCocktail"><Path d="M4.79807 3C2.08418 3 1.01074 6.51412 3.2614 8.0306L11.2506 13.4137V20.5H7.75061C7.3364 20.5 7.00061 20.8358 7.00061 21.25C7.00061 21.6642 7.3364 22 7.75061 22H16.2506C16.6648 22 17.0006 21.6642 17.0006 21.25C17.0006 20.8358 16.6648 20.5 16.2506 20.5H12.7506V13.4137L20.7399 8.03061C22.9905 6.51412 21.9171 3 19.2032 3H4.79807Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCocktail;
